module.exports = __webpack_public_path__ + "header-profile-skin-2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/patterns/header-profile-skin-2.png
// module id = 1733
// module chunks = 11